import { BrowserModule } from '@angular/platform-browser';
import { InjectionToken, NgModule, inject, provideAppInitializer } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LoginComponent } from './login/login.component';
import { provideTransloco, TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { TranslocoHttpLoader } from './loaders/transloco-loader';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FooterComponent } from './navigation/footer/footer.component';
import { HeaderComponent } from './navigation/header/header.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { AppConfigService, initAppConfigService } from '@justonweb/core';
import { NotificationModule } from '@justonweb/notification';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { AccessibilityStatementComponent } from './accessibility-statement/accessibility-statement.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { TestEnvironmentModule } from '@justonweb/dialogs';
import { BannerModule } from '@justonweb/banner';
import { UnderMaintenanceModule } from '@justonweb/under-maintenance';
import { ButtonsModule } from '@justonweb/web/shared/ui/buttons';
import { JustonwebLoginComponent } from './justonweb-login/justonweb-login.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DocumentComponent } from './document/document.component';

// Create custom Injection Token for loading appConfig
export const APP_CONFIG = new InjectionToken<any>('appConfig');

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    FooterComponent,
    PrivacyPolicyComponent,
    AccessibilityStatementComponent,
    TermsOfUseComponent,
    JustonwebLoginComponent,
    DocumentComponent
  ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        TranslocoModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        BrowserAnimationsModule,
        NotificationModule,
        NgxExtendedPdfViewerModule,
        TestEnvironmentModule,
        BannerModule,
        UnderMaintenanceModule,
        ButtonsModule,
        MatDialogModule,
        HeaderComponent
      ],
      providers: [
        AppConfigService,
        provideAppInitializer(() => {
            const initializerFn = (initAppConfigService)(inject(AppConfigService), inject(APP_CONFIG));
            return initializerFn();
        }),
        provideTransloco({
          config: {
            prodMode: environment.production,
            availableLangs: ['nl', 'fr', 'de'],
            defaultLang: 'nl',
            fallbackLang: 'nl',
            reRenderOnLangChange: true,
            missingHandler: {}
          },
          loader: TranslocoHttpLoader,
        }),
        TranslocoService,
        provideHttpClient(withInterceptorsFromDi()),
      ]
})
export class AppModule {
}
